import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { TModelItem } from "../../../services/api/instances/modelsApi/types";
import { getModelsReducerBuilder } from "./reducers";
import type { ModelsState } from "./types";

const initialState: ModelsState = {
  models: [],
  selectedModel: null,
  isInitialized: false,
  isLoading: false,
};

const modelsSlice = createSlice({
  name: "models",
  initialState,
  reducers: {
    setSelectedModel: (state, action: PayloadAction<TModelItem | null>) => {
      state.selectedModel = action.payload;
    },
  },
  extraReducers: (builder) => {
    getModelsReducerBuilder(builder);
  },
});

export const modelsReducers = modelsSlice.reducer;

export const { setSelectedModel } = modelsSlice.actions;
